import styled from 'styled-components/macro';

export const StyledDescription = styled.p`
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-bottom: 2rem;
`;
